import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const SERVICE_PATH = `${BASE_PATH_API}/showingscoordinator/membership`;

const actions = {
    getIntegrationStatus: {
        method: 'GET',
        url: `${SERVICE_PATH}/provision/status`
    },
    getIntegrationStatusOnly: {
        method: 'GET',
        url: `${SERVICE_PATH}/provision/statusOnly`
    },
    startProvision: {
        method: 'POST',
        url: `${SERVICE_PATH}/startprovision`
    },
    addUsersAndFinishProvision: {
        method: 'POST',
        url: `${SERVICE_PATH}/addusersandsync`
    },
    getUsersWithPartnerStatus: {
        method: 'GET',
        url: `${SERVICE_PATH}/users`
    },
    getUserWithPartnerStatus: {
        method: 'GET',
        url: `${SERVICE_PATH}/users/:userId`
    },
    getUserWithPartnerStatusOnly: {
        method: 'GET',
        url: `${SERVICE_PATH}/users/:userId/status`
    },
    addUserToIntegrationPartner: {
        method: 'POST',
        url: `${SERVICE_PATH}/users/:userId`
    },
    resendInviteEmail: {
        method: 'PUT',
        url: `${SERVICE_PATH}/users/:userId/resendInvite`
    },
    isUserProvisioned: {
        method: 'GET',
        url: `${SERVICE_PATH}/provision/isUserProvisioned`
    }
};

export function ShowingsCoordinatorApi() {
    return createActions(actions);
}
